import { render, staticRenderFns } from "./SettingsLogin.vue?vue&type=template&id=c6c11754&"
import script from "./SettingsLogin.vue?vue&type=script&lang=js&"
export * from "./SettingsLogin.vue?vue&type=script&lang=js&"
import style0 from "./SettingsLogin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports